import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';
import { useToast } from 'components/hooks/useToast';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

interface AnalyticsReportRequest {
  cohortId: number;
  timelineTag: string;
}

const generateGoalsDataExportsReport = async (requestData: AnalyticsReportRequest) => {
  try {
    const url = endpoints.dataExports.dataExportsReport;
    const response = await sendRequest({
      url,
      method: 'POST',
      credentials: 'include',
      body: {
        reportType: 'DETAILED_GOAL',
        cohortId: requestData.cohortId,
        baseFilter: {
          timelineTag: requestData.timelineTag,
        },
        rowGroupCols: [],
        pivotCols: [],
        pivotMode: false,
        filterModel: {},
        limit: null,
        sortModel: [],
      },
    });
    return response.entity;
  } catch (e) {
    console.error('Error failed to generate analytics report', e);
    throw e;
  }
};

export const useGenerateGoalsDataExportsReport = (requestData: AnalyticsReportRequest) => {
  const toast = useToast();

  return useQuery({
    queryKey: [
      REACT_QUERY_KEYS.dataExports.generateGoalsDataExportsReport,
      requestData?.cohortId,
      requestData?.timelineTag,
    ],
    queryFn: () => generateGoalsDataExportsReport(requestData),
    enabled: Boolean(requestData?.cohortId && requestData?.timelineTag),
    onError: () => {
      toast({
        title: 'Failed to generate report, please try again',
        status: 'error',
      });
    },
  });
};
